import Text from 'components/Text/Text';
import React from 'react';
import { TAssignDevicesSortBy } from '../../../../../devicesFormState/devicesFormContext';
import style from './DropdownMenu.module.scss';

interface IDropdownMenu {
	setSortBy: (value: TAssignDevicesSortBy) => void;
	sortBy: TAssignDevicesSortBy;
}

const DropdownMenu: React.FC<IDropdownMenu> = ({ sortBy, setSortBy }) => {
	return (
		<div className={style.container}>
			<div className={style.resetWrapper}>
				<span className={style.resetBtn} onClick={() => setSortBy('')}>
					<Text translationNameSpace="form" translationKey="resetButton" asFragment={true} />
				</span>
			</div>

			<div className={style.item}>
				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="sortByHardwareIdLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByHardwareIdA-Z" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('HardwareIdA-Z')}
						checked={sortBy === 'HardwareIdA-Z'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByHardwareIdZ-A" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('HardwareIdZ-A')}
						checked={sortBy === 'HardwareIdZ-A'}
						name="assignmentSort"
					/>
				</label>

				<div className={style.headingWrapper}>
					<Text
						translationNameSpace="form"
						translationKey="sortByTerminalIdLabel"
						theme="neutralLight"
						size="s"
					/>
				</div>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByTerminalId1-10" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('TerminalId1-10')}
						checked={sortBy === 'TerminalId1-10'}
						name="assignmentSort"
					/>
				</label>
				<label className={style.sortingControl}>
					<Text translationNameSpace="form" translationKey="sortByTerminalId10-1" size="s" />
					<input
						type="radio"
						className={style.radioBtn}
						onChange={() => setSortBy('TerminalId10-1')}
						checked={sortBy === 'TerminalId10-1'}
						name="assignmentSort"
					/>
				</label>
			</div>
		</div>
	);
};

export default React.memo(DropdownMenu);
